const ConsentLinkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_1530_15428)">
        <path
          d="M8 0C3.57841 0 0 3.578 0 8C0 12.4215 3.578 16 8 16C12.4216 16 16 12.422 16 8C16 3.57847 12.422 0 8 0ZM8 14.8837C4.20431 14.8837 1.11628 11.7957 1.11628 8C1.11628 4.20428 4.20431 1.11628 8 1.11628C11.7957 1.11628 14.8837 4.20428 14.8837 8C14.8837 11.7957 11.7957 14.8837 8 14.8837Z"
          fill="#F12A00"
        />
        <path
          d="M8.0003 6.66895C7.52642 6.66895 7.18945 6.86907 7.18945 7.16391V11.176C7.18945 11.4287 7.52642 11.6814 8.0003 11.6814C8.45311 11.6814 8.82164 11.4287 8.82164 11.176V7.16385C8.82164 6.86904 8.45311 6.66895 8.0003 6.66895Z"
          fill="#F12A00"
        />
        <path
          d="M8.00019 4.19434C7.51578 4.19434 7.13672 4.54184 7.13672 4.94199C7.13672 5.34218 7.51581 5.70021 8.00019 5.70021C8.47406 5.70021 8.85319 5.34218 8.85319 4.94199C8.85319 4.54184 8.47403 4.19434 8.00019 4.19434Z"
          fill="#F12A00"
        />
      </g>
      <defs>
        <clipPath id="clip0_1530_15428">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ConsentLinkIcon;
